import { Divider, Paper, Stack, Typography } from '@mui/material';
import { AbsColor } from '../../constants';
import { ICalendarSurvey } from '../../contracts/calendar-survey.contract';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { groupBy } from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import { CalendarAction } from '../../features/calendar.feature';

interface CalendarListItemDetailsProps {
    classNumber: string;
    year: number;
}

const CalendarListItemDetails = ({ classNumber, year }: CalendarListItemDetailsProps) => {
    const dispatch = useAppDispatch();
    const calendarItem = useAppSelector((state) => state.Calendar.List[`${classNumber}`]?.CalendarGroup?.find((f) => f.Year === year.toString()));
    const surveyFilters = useAppSelector((state) => state.Calendar.Filters.Surveys);

    const groupedLowRisk = calendarItem?.LowRisk ? groupBy(calendarItem.LowRisk, (item: ICalendarSurvey) => item.SurveyDescription) : {};
    const groupedMediumRisk = calendarItem?.MediumRisk ? groupBy(calendarItem.MediumRisk, (item: ICalendarSurvey) => item.SurveyDescription) : {};
    const groupedHighRisk = calendarItem?.HighRisk ? groupBy(calendarItem.HighRisk, (item: ICalendarSurvey) => item.SurveyDescription) : {};

    const handledCheckbox = (riskItems: ICalendarSurvey[]) => {
        const isSelected = surveyFilters?.some(
            (filter) => filter.SurveyDescription === riskItems[0].SurveyDescription && filter.ClassNumber === riskItems[0].ClassNumber && filter.SurveyDueDate === riskItems[0].SurveyDueDate
        );

        if (isSelected) {
            riskItems.forEach((item) => dispatch(CalendarAction.RemoveFilterSurvey(item)));
        } else {
            surveyFilters?.filter((item: ICalendarSurvey) => item.ClassNumber !== riskItems[0].ClassNumber).forEach((item: ICalendarSurvey) => dispatch(CalendarAction.RemoveFilterSurvey(item)));

            dispatch(CalendarAction.AddFilterSurvey(riskItems));
        }
    };

    const RenderRiskItems = (riskItems: ICalendarSurvey[] | undefined, color: string) => {
        return (
            <Stack direction={'column'}>
                {riskItems && (
                    <Stack direction={'column'} gap={0} style={{ borderLeft: 'solid', borderLeftWidth: '5px', borderLeftColor: color, paddingLeft: '2px', marginTop: '5px' }}>
                        <Typography variant="subtitle2" display={'block'}>
                            {riskItems[0].SurveyDescription}
                        </Typography>
                        <Typography variant="caption" display={'block'}>
                            Due Date: {riskItems[0].SurveyDueDate}
                        </Typography>
                        {riskItems?.map((item) => (
                            <div>
                                {riskItems.length > 1 && <Divider />}
                                <Typography variant="caption" display={'block'}>
                                    Certificate: {item.CertificateName}
                                </Typography>
                                <Typography variant="caption" display={'block'}>
                                    No. of Regulations: {item.RegulationCount}
                                </Typography>
                            </div>
                        ))}
                    </Stack>
                )}
            </Stack>
        );
    };

    return (
        <>
            {calendarItem && (Object.keys(groupedLowRisk).length > 0 || Object.keys(groupedMediumRisk).length > 0 || Object.keys(groupedHighRisk).length > 0) ? (
                <Paper elevation={1} style={{ padding: '10px', width: '100%' }}>
                    <Typography style={{ fontWeight: 'bold' }}>Surveys</Typography>

                    {Object.values(groupedHighRisk).map((riskItems: ICalendarSurvey[], index: number) => (
                        <Stack key={index} direction={'column'} gap={0}>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <Checkbox
                                        style={{ padding: 0 }}
                                        checked={surveyFilters?.some(
                                            (f) =>
                                                f.SurveyDescription === riskItems[0].SurveyDescription && f.ClassNumber === riskItems[0].ClassNumber && f.SurveyDueDate === riskItems[0].SurveyDueDate
                                        )}
                                        onClick={() => handledCheckbox(riskItems)}
                                    />
                                </Grid>
                                <Grid item xs>
                                    {RenderRiskItems(riskItems, AbsColor.HighRisk)}
                                </Grid>
                            </Grid>
                        </Stack>
                    ))}
                    {Object.values(groupedMediumRisk).map((riskItems: ICalendarSurvey[], index: number) => (
                        <Stack key={index} direction={'column'}>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <Checkbox
                                        style={{ padding: 0 }}
                                        checked={surveyFilters?.some(
                                            (f) =>
                                                f.SurveyDescription === riskItems[0].SurveyDescription && f.ClassNumber === riskItems[0].ClassNumber && f.SurveyDueDate === riskItems[0].SurveyDueDate
                                        )}
                                        onClick={() => handledCheckbox(riskItems)}
                                    />
                                </Grid>
                                <Grid item xs>
                                    {RenderRiskItems(riskItems, AbsColor.MediumRisk)}
                                </Grid>
                            </Grid>
                        </Stack>
                    ))}
                    {Object.values(groupedLowRisk).map((riskItems: ICalendarSurvey[], index: number) => (
                        <Stack key={index} direction={'column'}>
                            <Grid container alignItems="center">
                                <Grid item>
                                    <Checkbox
                                        style={{ padding: 0 }}
                                        checked={surveyFilters?.some(
                                            (f) =>
                                                f.SurveyDescription === riskItems[0].SurveyDescription && f.ClassNumber === riskItems[0].ClassNumber && f.SurveyDueDate === riskItems[0].SurveyDueDate
                                        )}
                                        onClick={() => handledCheckbox(riskItems)}
                                    />
                                </Grid>
                                <Grid item xs>
                                    {RenderRiskItems(riskItems, AbsColor.LowRisk)}
                                </Grid>
                            </Grid>
                        </Stack>
                    ))}
                </Paper>
            ) : (
                <>
                    <Paper elevation={1} style={{ padding: '10px', width: '100%' }}>
                        <Typography style={{ fontWeight: 'bold' }}>No Surveys</Typography>
                    </Paper>
                </>
            )}
        </>
    );
};

export default CalendarListItemDetails;
